(function () {
  const MAIN_HIDDEN_CLASS = "product__media-item--variant-hidden";
  const THUMB_HIDDEN_CLASS = "product__media-subitem--variant-hidden";

  function parseVariantIds(value) {
    if (!value) return [];
    return value
      .split(",")
      .map((id) => Number(id))
      .filter(Boolean);
  }

  function getMediaIdFromDataset(datasetValue) {
    if (!datasetValue) return null;
    return datasetValue.split("-").pop();
  }

  function shouldShowMedia({ mode, item, variantId, featuredMediaId }) {
    const mediaId = getMediaIdFromDataset(
      item.dataset.mediaId || item.dataset.mediaSubId
    );
    const attachedToVariant = item.dataset.attachedToVariant === "true";
    const variantIds = parseVariantIds(item.dataset.variantIds);

    if (mode === "show_all") return true;

    if (mode === "show_only_variant_media") {
      return Boolean(featuredMediaId && mediaId === String(featuredMediaId));
    }

    if (!attachedToVariant) return true;
    if (featuredMediaId && mediaId === String(featuredMediaId)) return true;
    return variantIds.includes(variantId);
  }

  function getMediaContainer(sectionId) {
    return document.querySelector(
      `[data-section="product-media-${sectionId}"]`
    );
  }

  function updateSwipers(container) {
    const sliderEl = container.querySelector(".js-media-list");
    const thumbsSlider = container.querySelector(".js-media-sublist");

    if (sliderEl?.swiper && !sliderEl.swiper.destroyed) {
      sliderEl.swiper.update();
    }

    if (thumbsSlider?.swiper && !thumbsSlider.swiper.destroyed) {
      thumbsSlider.swiper.update();
    }
  }

  function updateThumbsWrapperVisibility(container) {
    const thumbsWrapper = container.querySelector(
      ".product__media-sublist-wrapper"
    );
    if (!thumbsWrapper) return;

    const visibleThumbs = container.querySelectorAll(
      `[data-media-sub-id]:not(.${THUMB_HIDDEN_CLASS})`
    );
    thumbsWrapper.classList.toggle("hidden", visibleThumbs.length <= 1);
  }

  function updateVariantMediaDisplay(sectionId, variant) {
    const container = getMediaContainer(sectionId);
    if (!container) return;

    const mode = container.dataset.variantMediaDisplay || "show_all";
    const variantId = variant?.id;
    const featuredMediaId = variant?.featured_media?.id;

    const mainItems = container.querySelectorAll("[data-media-id]");
    const thumbItems = container.querySelectorAll("[data-media-sub-id]");

    if (mode === "show_all") {
      mainItems.forEach((item) => item.classList.remove(MAIN_HIDDEN_CLASS));
      thumbItems.forEach((item) => item.classList.remove(THUMB_HIDDEN_CLASS));
      updateThumbsWrapperVisibility(container);
      updateSwipers(container);
      return;
    }

    mainItems.forEach((item) => {
      const show = shouldShowMedia({
        mode,
        item,
        variantId,
        featuredMediaId,
      });
      item.classList.toggle(MAIN_HIDDEN_CLASS, !show);
    });

    thumbItems.forEach((item) => {
      const show = shouldShowMedia({
        mode,
        item,
        variantId,
        featuredMediaId,
      });
      item.classList.toggle(THUMB_HIDDEN_CLASS, !show);
    });

    updateThumbsWrapperVisibility(container);
    updateSwipers(container);
  }

  function initVariantMediaGrouping(container) {
    const mode = container.dataset.variantMediaDisplay;
    if (!mode || mode === "show_all") return;

    const sectionId = container.dataset.section?.replace("product-media-", "");
    if (!sectionId) return;

    const variantPicker = document.querySelector(`#variant-picker-${sectionId}`);
    const selectedVariantScript = variantPicker?.querySelector(
      "[data-selected-variant]"
    );
    if (!selectedVariantScript) return;

    try {
      const variant = JSON.parse(selectedVariantScript.textContent);
      updateVariantMediaDisplay(sectionId, variant);
    } catch (error) {
      console.error(error);
    }
  }

  function initAllVariantMediaGrouping() {
    document
      .querySelectorAll("[data-variant-media-display]")
      .forEach(initVariantMediaGrouping);
  }

  window.updateVariantMediaDisplay = updateVariantMediaDisplay;

  document.addEventListener("DOMContentLoaded", initAllVariantMediaGrouping);
  document.addEventListener("shopify:section:load", initAllVariantMediaGrouping);
})();
